<template>
<!--  <div>-->
<!--    <button type="button" class="icon-box zzim" @click="toggleFn" :aria-pressed="isOn" :aria-label="ariaLabelText">-->
<!--      <component :is="zzimIcon" />-->
<!--      <span class="icon-txt">{{title}}</span>-->
<!--    </button>-->
<!--  </div>-->
  <button type="button" class="btn-attention" @click="toggleFn" :aria-pressed="isOn" :aria-label="ariaLabelText">
    {{title}}
  </button>
</template>

<script>
// import SubscribeButton from '@/assets/svg/common/ic_detail_plus_off.svg'
// import UnSubscribeButton from '@/assets/svg/common/ic_detail_plus_on.svg'
// import LikeButton from '@/assets/svg/common/ic_detail_like_off.svg'
// import UnLikeButton from '@/assets/svg/common/ic_detail_like_on.svg'

export default {
  name: 'IconBoxZzim',
  components: {
    // SubscribeButton,
    // UnSubscribeButton,
    // LikeButton,
    // UnLikeButton
  },
  data () {
    return {
      ariaLabelText: ''
    }
  },
  props: {
    // section: {
    //   type: String
    // },
    toggleFn: {
      type: Function
    },
    isOn: {
      type: Boolean
    },
    title: {
      type: String
    },
    // zzimIcon: {
    //   type: String
    // },
    ariaLabel: {
      type: String
    }
  },
  created () {
    this.ariaLabelText = this.title || this.ariaLabel
  }
}
</script>
